import Image from "next/image";
import type { ReactNode } from "react";

import { cn } from "@/utils/lib";

export type SelectTriggerValueOption = {
  value: string;
  label: ReactNode;
  iconAlt?: string;
  iconNode?: ReactNode;
  iconSrc?: string;
};

type SelectTriggerValueProps = {
  value: string | null | undefined;
  options: ReadonlyArray<SelectTriggerValueOption>;
  placeholder?: ReactNode;
  className?: string;
  labelClassName?: string;
};

export const SelectTriggerValue = ({
  value,
  options,
  placeholder,
  className,
  labelClassName,
}: SelectTriggerValueProps) => {
  const option = options.find((candidate) => candidate.value === value);

  if (!option) {
    return placeholder ? (
      <span className="text-muted-foreground">{placeholder}</span>
    ) : null;
  }

  const icon =
    option.iconNode ??
    (option.iconSrc ? (
      <Image
        src={option.iconSrc}
        alt={option.iconAlt ?? ""}
        width={20}
        height={20}
        className="block size-5 rounded-full object-cover"
      />
    ) : null);

  return (
    <span
      className={cn("flex min-w-0 items-center gap-2 leading-none", className)}
    >
      {icon ? (
        <span
          className="
            flex size-5 shrink-0 items-center justify-center overflow-hidden
            rounded-full
          "
        >
          {icon}
        </span>
      ) : null}
      <span
        className={cn("flex min-w-0 items-center truncate", labelClassName)}
      >
        {option.label}
      </span>
    </span>
  );
};
